/**
 * Custom hooks for client management (Epic 2)
 */
import useSWR from "swr";
import { fetcher, api } from "../lib/api";

/**
 * Hook for client detail (admin)
 */
export function useClientDetail(clientId) {
  const { data, error, isLoading, mutate } = useSWR(
    clientId ? `/api/admin/clients/${clientId}` : null,
    fetcher
  );
  
  return {
    client: data,
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Update client profile
 */
export async function updateClientProfile(clientId, data) {
  return api.post(`/api/admin/clients/${clientId}/profile`, data);
}

/**
 * Update feature toggles
 */
export async function updateFeatureToggles(clientId, data) {
  return fetcher(`/api/admin/clients/${clientId}/features`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

/**
 * Toggle client active status
 */
export async function toggleClientActive(clientId, isActive) {
  return fetcher(`/api/admin/clients/${clientId}/toggle-active?is_active=${isActive}`, {
    method: "POST",
  });
}
